import React from "react";

export default function FeaturePlaceholder({ title, description }) {
  return (
    <div className="card">
      <div className="card-body">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}

